// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Address, type AddressWireFormat, NewAddress } from '../Address/Address';
import { LatLong, type LatLongWireFormat, NewLatLong } from '../LatLong/LatLong';

export class LocationResult {
  readonly location: LatLong;
  readonly formattedAddress: string;
  readonly address: Address;
  readonly placeID: string;

  constructor(data: { [key: string]: any } = {}) {
    this.location = NewLatLong(data.location);
    this.formattedAddress = data.formattedAddress === undefined ? '' : data.formattedAddress;
    this.address = NewAddress(data.address);
    this.placeID = data.placeID === undefined ? '' : data.placeID;
  }

  static zero(): LocationResult {
    const zeroValues: ExcludeMethodsDeep<LocationResult> = {
      location: LatLong.zero(),
      formattedAddress: '',
      address: Address.zero(),
      placeID: '',
    };
    return new LocationResult(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type LocationResultWireFormat = {
  location: LatLongWireFormat;
  formattedAddress: string;
  address: AddressWireFormat;
  placeID: string;
};

type NewLocationResultProps = PartialDeep<LocationResult, { recurseIntoArrays: true }>;
export const NewLocationResult: (props: NewLocationResultProps) => LocationResult = (props) =>
  new LocationResult(props);

type NewLocationResultFromWireFormatProps = PartialDeep<
  LocationResultWireFormat,
  { recurseIntoArrays: true }
>;
export const NewLocationResultFromWireFormat: (
  props: NewLocationResultFromWireFormatProps,
) => LocationResult = (props) => new LocationResult(props);
